import { Text } from "@ui-kitten/components";
import BaseCard, { BaseCardListItem } from "components/BaseCard";
import Chevron from "components/Chevron";
import { TicketCartDetails } from "features/types";
import React, { useState } from "react";
import { formatCurrency } from "utils/appUtils";
import { getAllItemsPrice } from "../helpers";
import FeeDetails from "./FeeDetails";

const CartSummary: React.FC<{
  charge: TicketCartDetails;
}> = (props) => {
  const [showPriceBreakdown, setShowPriceBreakdown] = useState(false);

  const {
    charge: {
      priceType,
      feeItems,
      totalCredits,
      totalPoints,
      totalPrice,
      totalCreditCardCharges,
    },
  } = props;
  return (
    <BaseCard title="Cart Summary">
      <BaseCardListItem
        title="Amount Due"
        accessoryRight={
          <Text category="s1">{formatCurrency(totalCreditCardCharges)}</Text>
        }
      />

      <BaseCardListItem
        title="Price Breakdown"
        showArrow={true}
        accessoryRight={
          <Text category="s1">
            {showPriceBreakdown ? (
              <Chevron direction="up" />
            ) : (
              <Chevron direction="down" />
            )}
          </Text>
        }
        onPress={() => setShowPriceBreakdown(!showPriceBreakdown)}
      />

      {showPriceBreakdown && (
        <>
          <BaseCardListItem
            title="Ticket Price:"
            description="The base price of your selected ticket(s)"
            accessoryRight={
              <Text category="s1">
                {getAllItemsPrice(props.charge, priceType)}
              </Text>
            }
          />
          {feeItems && feeItems.length > 0 && (
            <FeeDetails feeItems={feeItems} />
          )}

          <BaseCardListItem
            title="Total Price:"
            description="Includes all fees and taxes"
            accessoryRight={
              <Text category="s1">{formatCurrency(totalPrice)!}</Text>
            }
          />

          {/* NOTE: totalCreditCardCharges, and totalCredits should always be displayed as dollars, 
    regardless of the priceType attribute. */}
          {Number(totalPoints) > 0 && (
            <BaseCardListItem
              title="Funds on Account:"
              description="Available bank balance to cover the total price."
              accessoryRight={
                <Text category="s1" style={{ color: "rgb(26, 142, 14)" }}>
                  {
                    formatCurrency(totalPoints, {
                      priceType: priceType,
                    })!
                  }
                </Text>
              }
            />
          )}
          {Number(totalCredits) > 0 && (
            <BaseCardListItem
              title="Account Credit:"
              description="Available account credit to cover the total price."
              accessoryRight={
                <Text category="s1" style={{ color: "rgb(26, 142, 14)" }}>
                  {
                    formatCurrency(totalCredits, {
                      priceType: priceType,
                    })!
                  }
                </Text>
              }
            />
          )}
        </>
      )}
    </BaseCard>
  );
};

export default CartSummary;
